// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/doc/Doc.css
// module id = 649
// module chunks = 0